export default {
    header: {
        title: 'SoGate',
        home: 'Home',
        feature: 'Feature',
        service: 'Services',
        about: 'About',
        contact: 'Contact',
    },
    main: {
        home: {
            title: 'Secure & Optimized Zero Trusted Network',
            subtitle1: 'Secure access to private data for your distributed workforce',
            subtitle2: 'Replace corporate VPNs with a more secure, usable and performant zero trust access solution'
        },
        feature: {
            title: 'SoGate - Secure Access Service Edge',
            subtitle1: 'Validation. Filtering. Quarantine. Check. Cover all the devices you manage, even the ones you don\'t manage.',
            subtitle2: 'Your employees, partners, and customers need a secure, fast, and reliable network to get their work done. Leveraging our global edge network replaces traditional security boundaries, enabling a faster and more secure Internet for teams around the world.',
            list1: {
                title: 'Protect your app and data',
                subtitle1: 'Identity and application agnostic, allowing you to protect any application, SaaS, cloud, or on-premises with your preferred identity provider.',
                subtitle2: 'Apply strong, consistent authentication methods to even legacy applications with IP firewall and Zero Trust rules.',
            },
            list2: {
                title: 'Block threats on the Internet, known and unknown',
                subtitle1: 'Block access to known malicious, dangerous, or harmful destinations.',
                subtitle2: 'Content and application-based categories make building policies and auditing security or compliance incidents easy.',
            },
            list3: {
                title: 'Built for Zero IT admins',
                subtitle1: 'Designed for zero trust network administrators, without professional managers, simplify complex Settings, low learning costs.',
                subtitle2: 'Deploys in minutes without infrastructure changes or renaming.',
                subtitle3: 'Simplify Administrative Workloads. Centrally manage access through one admin console.',
            },
            list4: {
                title: 'SASE',
                subtitle1: 'Even if the users have completed the authentication process, they can only access the resources that you have provided to them – this limits the potential radius of the attack.',
            }
        },
        service: {
            title: 'Services',
            subtitle: 'Stop data loss, malware, and phishing with the best-performing Zero Trust application access and Internet browsing solution.',
            list1: 'Your network is invisible to the internet, which greatly reduces the risk of opportunistic attacks. ',
            list2: 'Stop phishing and malware before they can attack, and contain compromised devices before they cause damage. ',
            list3: 'Directs traffic from enterprise devices (supporting Windows, Mac, iOS, and Android clients) to ZTN. ',
            list4: 'comes with traffic checks from the policy builder, providing high-level control over filtered data flows. ',
            list5: 'Enforce consistent, role-based access control for all SaaS and self-hosted applications -cloud, hybrid cloud, or on-premises. ',
            list6: 'Accelerate remote access and reduce VPN dependency with ZTNA deployed on a globally distributed, DDoS attase-resistant edge network. ',
        },
        about: {
            title: 'About',
            subtitle1: 'In today\'s tough cybersecurity environment, users need access to resources from anywhere, on any device. it is critical to protect your Anywhere Workforce without compromising the user experience. We at sogate.net provide you with a complete product suite to ensure: secure, reliable, zero-trust connections to private applications, cloud services, and websites.',
            subtitle2: 'SoGate is an easy-to-use cloud-based Zero Trust Network Access (ZTNA) solution that provides high-performance, secure and reliable remote access to any application or resource, whether on-premises or in the cloud, and ensures unified policy enforcement and blocks advanced cyber threats without compromising performance.',
        },
        contact: {
            title: 'Contact',
            address: 'Our Address',
            address_value: 'Room 1001, No. 621, Tianhe Road, Tianhe District, Guangzhou',
            email: 'Email Us',
            phone: 'Call Us',
        }
    },
    footer: {
        copyright: 'Copyright © {year} Guangzhou Shouyun Technology Co.  All Rights Reserved',
    }
}